var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 204.8,
    height: 153.6,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 54.2 40.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29.9 26.6h-4.4v-1.2c0-1.4.2-2.6.7-3.5.5-1 1.4-2 2.8-3.1s2.3-1.9 2.6-2.3a3 3 0 0 0 .6-1.8c0-1-.4-1.8-1.1-2.4-.8-.7-1.8-1-3-1-1.3 0-2.3.3-3.2 1-.8.7-1.4 1.8-1.7 3.2l-4.4-.5c.1-2.1 1-3.8 2.6-5.3a9.3 9.3 0 0 1 6.4-2.1c2.8 0 5 .7 6.6 2.2a6.6 6.6 0 0 1 2.5 5c0 1-.3 2.1-.9 3a20 20 0 0 1-3.9 4c-1 .8-1.6 1.5-1.9 2-.2.5-.3 1.4-.3 2.8zM25.5 33v-4.9h4.8v4.9h-4.8z",
    style: {
      fill: "#2b2a29",
      fillRule: "nonzero"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.c1e7470649456a0d245dc6bd03f6ecbb.svg";
export { ForwardRef as ReactComponent };